import { clubRepositoryKey } from '@/fairplayer/domain/club/ClubRepository';
import { inject, onMounted } from 'vue';
import { useRouter } from 'vue-router';

export default {
  name: 'ClubsPage',

  setup() {
    const router = useRouter();
    const clubRepository = inject(clubRepositoryKey)!;

    onMounted(async () => {
      clubRepository.clearSelectedClub();
      await router.replace({ name: 'homepage' });
    });
  },
};
